import React, { ReactElement } from 'react';
import { BaseStylesContainerStyled } from './baseStyles.styled';
import { BaseStylesPropsModel } from './baseStyles.model';

export const BaseStylesContainer = ({
  styles: __html,
}: BaseStylesPropsModel): ReactElement => (
  <BaseStylesContainerStyled dangerouslySetInnerHTML={{ __html }} />
);
